const GEA_COLOR_PALETTE = {
  jllRed: "#E30613",
  jllWhite: "#FFFFFF",
  jllBlack: "#000000",
  jllSteel: "#626468",
  jllConcrete: "#B1B2B4",
  jllStone: "#DBD6C7",

  /* SUPPORTING */
  jllViolet: "#7874B5",
  jllViolet75: "#9A97C7",
  jllViolet50: "#BBB9DA",
  jllViolet25: "#DDDCED",
  jllPurple: "#602376",
  jllPurple75: "#885A98",
  jllPurple50: "#AF91BA",
  jllPurple25: "#D7C8DD",
  jllRaspberry: "#9A054A",
  jllRaspberry75: "#B34477",
  jllRaspberry50: "#CD82A4",
  jllRaspberry25: "#E6C0D2",
  jllOrange: "#ED700A",
  jllOrange75: "#F19447",
  jllOrange50: "#F6B784",
  jllOrange25: "#FBDBC2",
  jllWater: "#D3E3EA",
  jllGreenSpace: "#BBCEA4",

  jllDarkRed: "#CF0B0D",
  jllDarkRed08: "#D93C3D",
  jllDarkRed04: "#EC9D9E",
  jllDarkRed03: "#F1B5B6",
  jllMediumRed: "#FFCACA",
  jllLightRed: "#F9EEEE",
  jllKhaki: "#D4C3A7",
};

//const HIGHCHART_COLORS = {
//    supplyColor: Highcharts.Color(GEA_COLOR_PALETTE.jllBlack).get(),
//    closingColor: Highcharts.Color(GEA_COLOR_PALETTE.jllSteel).get(),
//    sellTrendColor: Highcharts.Color(GEA_COLOR_PALETTE.jllRed).get(),
//    rentTrendColor: Highcharts.Color(GEA_COLOR_PALETTE.jllBlack).get(),
//    sellAffordabilityColor: Highcharts.Color(GEA_COLOR_PALETTE.jllBlack).get(),
//    rentAffordabilityColor: Highcharts.Color(GEA_COLOR_PALETTE.jllSteel).get(),
//    sellColor: Highcharts.Color(GEA_COLOR_PALETTE.jllRed).get(),
//    rentColor: Highcharts.Color(GEA_COLOR_PALETTE.jllBlack).get(),
//    liquidityColor: Highcharts.Color(GEA_COLOR_PALETTE.jllRed).get(),
//    perCapitaColor: Highcharts.Color(GEA_COLOR_PALETTE.jllBlack).get(),
//    householdColor: Highcharts.Color(GEA_COLOR_PALETTE.jllSteel).get(),
//    unemploymentColor: Highcharts.Color(GEA_COLOR_PALETTE.jllBlack).get(),
//    last10YearsColor: Highcharts.Color(GEA_COLOR_PALETTE.jllRed).get(),
//    avgAgingYearColor: Highcharts.Color(GEA_COLOR_PALETTE.jllRed).get(),
//    retailYieldColor: Highcharts.Color(GEA_COLOR_PALETTE.jllBlack).get(),
//    ttdColor: Highcharts.Color(GEA_COLOR_PALETTE.jllSteel).get(),

//    countryColor: Highcharts.Color(GEA_COLOR_PALETTE.jllRed).get(),
//	backgroundColor: Highcharts.Color('#f9f9f9').get(),

//	demographicColors: [
//        Highcharts.Color(GEA_COLOR_PALETTE.jllRed).get(),
//        Highcharts.Color(GEA_COLOR_PALETTE.jllSteel).get(),
//        Highcharts.Color(GEA_COLOR_PALETTE.jllConcrete).get(),
//        Highcharts.Color(GEA_COLOR_PALETTE.jllKhaki).get(),
//        Highcharts.Color(GEA_COLOR_PALETTE.jllStone).get(),
//	]
//}

/**
 * LIBRERÍA DE UTILIDADES
 * */
export default {
  /**
   * GUID Generator.
   * */
  newGuid: function () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  },
  newGuidJoin: function () {
    var guid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
    var cleanGuid = guid.replace(/-/g, "");
    return cleanGuid;
  },
  newId: function () {
    var guid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
    var cleanGuid = guid.replace(/-/g, "");
    return "i" + cleanGuid;
  },

  numberWithThousandSeparator: function (value, separator, floor) {
    if (floor) {
      return Math.floor(value)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    } else {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }
  },

  GeaColorPalette: GEA_COLOR_PALETTE,
};
